import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

export const ProposalConfirmation = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [details, setDetails] = useState(null);
  const [, setIsLoading] = useState(false);

  useEffect(() => {
    if (location.state?.email) {
      setDetails(location.state);
      
      // Simulation d'envoi d'email
      const sendEmail = async () => {
        setIsLoading(true);
        try {
          // Ici, vous intégreriez votre logique d'envoi d'email réelle
          // Par exemple avec un service comme SendGrid, Mailjet, etc.
          console.log("Envoi d'email à", location.state.email);
          
          // Simuler un délai pour l'envoi
          await new Promise(resolve => setTimeout(resolve, 1500));
          
          // Marquer comme envoyé dans Supabase
          // Cette étape serait normalement gérée par votre backend
          setIsLoading(false);
        } catch (error) {
          console.error("Erreur d'envoi d'email:", error);
          setIsLoading(false);
        }
      };
      
      sendEmail();
    } else {
      // Rediriger si aucun détail n'est disponible
      navigate('/propose-museum');
    }
  }, [location, navigate]);

  if (!details) {
    return (
      <div className="flex justify-center items-center h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-t-4 border-b-4 border-indigo-600"></div>
      </div>
    );
  }

  return (
    <div className="p-6 max-w-3xl mx-auto">
      <div className="text-center mb-8">
        <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-green-100 text-green-600 mb-4">
          <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
          </svg>
        </div>
        <h1 className="text-3xl font-bold mb-2">Proposition envoyée avec succès</h1>
        <p className="text-gray-600">
          Un email contenant votre proposition a été envoyé à l'adresse {details.email}
        </p>
      </div>

      <div className="bg-white rounded-lg shadow p-6 mb-8">
        <h2 className="text-xl font-semibold mb-4">Détails de votre proposition</h2>
        
        <div className="space-y-4">
          <div>
            <h3 className="font-medium text-gray-700">Œuvre proposée</h3>
            <p className="text-gray-900">{details.artworkTitle}</p>
          </div>
          
          <div>
            <h3 className="font-medium text-gray-700">Institution ciblée</h3>
            <p className="text-gray-900">{details.institution}</p>
          </div>
        </div>
      </div>

      <div className="bg-blue-50 p-6 rounded-lg mb-8">
        <h2 className="text-lg font-semibold mb-3">Prochaines étapes</h2>
        
        <ol className="list-decimal pl-5 space-y-2">
          <li className="text-gray-700">
            <span className="font-medium">Consultez votre boîte de réception</span> - Vous trouverez un email avec votre proposition formatée.
          </li>
          <li className="text-gray-700">
            <span className="font-medium">Transférez la proposition</span> - Envoyez l'email à l'institution que vous avez choisie.
          </li>
          <li className="text-gray-700">
            <span className="font-medium">Suivez les réponses</span> - Une fois envoyée, suivez les réponses de l'institution dans votre gestionnaire d'œuvres.
          </li>
        </ol>
      </div>

      <div className="bg-amber-50 p-6 rounded-lg mb-8">
        <div className="flex items-start">
          <div className="flex-shrink-0 text-amber-600">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          </div>
          <div className="ml-3">
            <h3 className="font-medium text-amber-800">Besoin d'aide professionnelle ?</h3>
<p className="text-amber-700 mt-1">
  Vous pouvez toujours opter pour notre service de placement professionnel pour 
  maximiser vos chances de succès.{" "}
  <a
    href="https://quangartadvisory.com"
    target="_blank"
    rel="noopener noreferrer"
    className="text-blue-600 underline hover:text-blue-800"
  >
    En savoir plus
  </a>
</p>


          </div>
        </div>
      </div>

      <div className="flex justify-center mt-8">
        <button 
          onClick={() => navigate('/dashboard')}
          className="bg-indigo-600 text-white px-6 py-2 rounded-md hover:bg-indigo-700"
        >
          Retour à mon tableau de bord
        </button>
      </div>
    </div>
  );
};